module.exports = __webpack_public_path__ + "img/1F1F5-1F1F1.01c15b1e.svg";